import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'app/_controls/base.component';
import { Facility } from 'app/_core/models';

@Component({
  selector: 'app-facility-location',
  templateUrl: './facility-location.component.html'
})
export class FacilityLocationComponent  extends BaseComponent implements OnInit {
  @Input() facility: Facility;

  constructor() {
    super();
  }

  // Methods implement
  ngOnInit() {}
}
